import {PaymentMethod} from "./PaymentMethod";

export const PaymentMethodNames: Record<PaymentMethod, string> = {
  [PaymentMethod.CREDIT_CARD]: "Tarjeta de Credito",
  [PaymentMethod.CASH]: "Efectivo",
  [PaymentMethod.BANK_TRANSFER]: "Transferencia",
  [PaymentMethod.BANK_TRANSFER_MP]: "Transferencia MP",
  [PaymentMethod.AUTOMATIC_DEBIT]: "Debito Automatico",
  [PaymentMethod.PAYMENT_CHECK]: "Cheque",
};
